import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faCarSide, faChartPie, faMapMarked, faUserGraduate, faUserFriends, faUserTie, faUserCircle, faTable, faUsers, faUserSecret, faBars, faRoute, faNewspaper, faImage, faComments, faBiking } from '@fortawesome/free-solid-svg-icons';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';

const NavbarVerticalMenuItem = ({ route }) => {

  let faIcon = faChartPie;
  if (route.icon === 'car-side') {
    faIcon = faCarSide;
  }
  if (route.icon === 'school') {
    faIcon = faSchool;
  }
  if (route.icon === 'map-marked') {
    faIcon = faMapMarked;
  }
  if (route.icon === 'user-graduated') {
    faIcon = faUserGraduate;
  }
  if (route.icon === 'user-friends') {
    faIcon = faUserFriends;
  }
  if (route.icon === 'user-tie') {
    faIcon = faUserTie;
  }
  if (route.icon === 'user-circle') {
    faIcon = faUserCircle;
  }
  if (route.icon === 'table') {
    faIcon = faTable;
  }
  if (route.icon === 'users') {
    faIcon = faUsers;
  }
  if (route.icon === 'user-secret') {
    faIcon = faUserSecret;
  }
  if (route.icon === 'bars') {
    faIcon = faBars;
  }
  if (route.icon === 'route') {
    faIcon = faRoute;
  }
  if (route.icon === 'newspaper') {
    faIcon = faNewspaper;
  }
  if (route.icon === 'images') {
    faIcon = faImage;
  }
  if (route.icon === 'comments') {
    faIcon = faComments;
  }
  if (route.icon === 'biking') {
    faIcon = faBiking;
  }

  return (
    <Flex alignItems="center">
      {route.icon && (
        <span className="nav-link-icon">
          <FontAwesomeIcon icon={faIcon} />
        </span>
      )}
      <span className="nav-link-text ps-1">{route.name}</span>
      {route.badge && (
        <SoftBadge pill bg={route.badge.type} className="ms-2">
          {route.badge.text}
        </SoftBadge>
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired
};

export default React.memo(NavbarVerticalMenuItem);
